import { AppConfig } from './../app.config';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
    name: 'timeduration'
})
export class TimeDurationPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        return this.toLatenessToText(value);
    }

    private toLatenessToText(minutesLate: number) {
        minutesLate = (minutesLate % 1440);
        if (minutesLate < 60) {
            return minutesLate + ' min';
        } else {
            return moment().startOf('day').add(minutesLate, 'minutes').format('HH:mm');
        }
    }

}
